import React, { useEffect, useState } from 'react'
import { withStyles, Typography, CircularProgress } from '@material-ui/core'
import styles from './styles'
import { PDFDownloadLink } from '@react-pdf/renderer'
import { PdfStyleSheet } from './pdf-export/pdf-style'
import { initialThemeSettings } from 'src/model/theme'
import { useSelector } from 'react-redux'
import MyDoc from './pdf-export/full-pdf-download'
import { convertJpgToPng } from './pdf-export/utils'
import URL from 'src/api/url'
import UserType from 'src/model/user-types'
import { CoreButton } from 'src/components/core'

const PdfCourse = props => {
  const { classes, me } = props
  const entity = useSelector(state => state.course.entity)
  const [processedCards, setProcessedCards] = useState([])
  const [coverpageText, setCoverpageText] = useState(
    JSON.parse(entity?.settingDtos.find(x => x.key == 'general')?.value)
      .coverPageText,
  )
  const pageUrl = window.location.pathname.split('/')[1]
  const courseSettings = useSelector(state => state.course.landingPageSettings)
  const collectionSettings = useSelector(
    state => state.collection.landingPageSettings,
  )
  // Then conditionally use the results
  const landingPageData =
    pageUrl === 'mini-course' ? courseSettings : collectionSettings
  var landingPageMain = landingPageData?.sections.find(x => x.type === 'Main')
  var landingPageHeader = landingPageData?.sections.find(
    x => x.type === 'Header',
  )
  const userControl =
    UserType[me.userRoleId] == 'Basic' ||
    UserType[me.userRoleId] == 'AppSumo (Tier 1)'

  useEffect(() => {
    if (entity) {
      setCoverpageText(
        JSON.parse(entity?.settingDtos.find(x => x.key == 'general')?.value)
          .coverPageText,
      )
    }
  }, [entity])
  const [isProcessing, setIsProcessing] = useState(true)
  const [size, setSize] = useState()
  let themeSettings = initialThemeSettings
  let logo = null

  if (entity && entity.settingDtos.find(x => x.key == 'theme') != undefined) {
    themeSettings = JSON.parse(
      entity.settingDtos.find(x => x.key == 'theme').value,
    )
  }

  const pdfStyles = PdfStyleSheet(themeSettings)

  let cards = entity ? entity.cardDtos : []

  async function convertCoverImageUrl() {
    let coverImage = ''

    if (entity?.coverImageUrl) {
      coverImage =
        entity.coverImageUrl.includes('https://') ||
        entity.coverImageUrl.includes('data:image')
          ? entity.coverImageUrl
          : URL.CDN + entity.coverImageUrl + '?not-from-cache-please2'

      coverImage = await convertJpgToPng(coverImage)

      entity.coverImageUrl = coverImage
    } else {
      entity.coverImageUrl = ''
    }

    const parser = new DOMParser()
    const doc = parser.parseFromString(coverpageText, 'text/html')
    const images = doc.getElementsByTagName('img')

    try {
      for (let img of images) {
        const originalSrc = img.getAttribute('src')
        if (originalSrc && !originalSrc.startsWith('data:')) {
          const base64Data = await convertJpgToPng(originalSrc)
          img.setAttribute('src', base64Data)
        }
      }

      setCoverpageText(doc.documentElement.outerHTML)
    } catch (error) {
      throw new Error('Error converting images: ' + error.message)
    }
  }

  async function processCards(cards) {
    // Use Promise.all to wait for all promises to resolve

    await convertCoverImageUrl()

    const processedCards = await Promise.all(
      cards.map(async card => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(card.text, 'text/html')
        const images = doc.getElementsByTagName('img')

        try {
          for (let img of images) {
            const originalSrc = img.getAttribute('src')
            if (originalSrc && !originalSrc.startsWith('data:')) {
              const base64Data = await convertJpgToPng(originalSrc)
              img.setAttribute('src', base64Data)
            }
          }

          card.text = doc.documentElement.outerHTML
        } catch (error) {
          throw new Error('Error converting images: ' + error.message)
        }
        //
        if (
          card.mediaDtos &&
          card.mediaDtos.length > 0 &&
          card.mediaDtos[0].mediaType === 1 &&
          card.mediaDtos[0].mediaUrl.includes('jpg') &&
          !card.mediaDtos[0].mediaUrl.includes('data:image')
        ) {
          try {
            let srcUrl = card.mediaDtos[0].mediaUrl.includes('https')
              ? card.mediaDtos[0].mediaUrl
              : URL.CDN + card.mediaDtos[0].mediaUrl

            const jpgUrl = srcUrl // Your JPG image URL
            const pngDataUrl = await convertJpgToPng(jpgUrl)
            card.mediaDtos[0].mediaUrl = pngDataUrl
            return card
          } catch (error) {
            console.error('Error converting image:', error)
            return card
          }
        } else {
          return card
        }
      }),
    )
    setIsProcessing(false)

    return processedCards.filter(card => card !== null)
  }

  useEffect(() => {
    const initializeCards = async () => {
      try {
        setIsProcessing(true)
        const processed = await processCards(cards)
        setProcessedCards(processed)
      } catch (error) {
        console.error('Error processing cards:', error)
      } finally {
        //setIsProcessing(false)
      }
    }

    initializeCards()
  }, [cards]) // Dependencies array includes cards to re-run when cards change

  function formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
  }
  if (!entity) {
    return null
  }
  return (
    <div className={classes.customDomain__root}>
      {userControl ? (
        <>
          <Typography fontSize="14px" fontWeight={400}>
            You can export your mini-course as a PDF for easy sharing and
            printing.{' '}
          </Typography>
          <img src={'/assets/Upgrade.png'} alt="rocket!" />
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <Typography fontSize="16px" fontWeight={500}>
              Upgrade to Pro Plan
            </Typography>
            <div className={classes.badge}>
              <Typography
                fontSize={'11px'}
                fontWeight={500}
                style={{ color: '#015FFB' }}
              >
                Pro
              </Typography>
            </div>
          </div>
          <Typography fontSize="14px" fontWeight={400}>
            Upgrade to the Pro Plan to download as PDF your courses and access
            exclusive features.
          </Typography>
          <CoreButton
            fullWidth
            onClick={() => {
              window.location.href = '/pricing'
            }}
          >
            Upgrade to the Pro
          </CoreButton>
        </>
      ) : (
        <>
          {' '}
          <Typography className={classes.embedInstructionText}>
            You can export your mini-course as a PDF for easy sharing and
            printing.
          </Typography>
          <div className={classes.pdfContainer}>
            {isProcessing ? (
              <CircularProgress size={36} />
            ) : (
              <img
                src="/assets/pdf-document-svgrepo-com_1.svg"
                alt="pdf-icon"
                className={classes.pdfIcon}
              />
            )}

            <Typography className={classes.fileName}>
              {entity?.name + '.pdf'}
            </Typography>
            {size && (
              <Typography className={classes.fileSize}>{size}</Typography>
            )}
          </div>
          <div>
            {!isProcessing && (
              <PDFDownloadLink
                className={classes.downloadButton}
                disabled={isProcessing}
                document={
                  <MyDoc
                    cards={processedCards}
                    themeSettings={themeSettings}
                    logo={logo}
                    entity={entity}
                    coverText={coverpageText}
                    landingPageMain={landingPageMain}
                    landingPageHeader={landingPageHeader}
                  />
                }
                fileName={entity?.name + '.pdf'}
              >
                {({ blob, url, loading, error }) => {
                  setSize(formatBytes(blob?.size))
                  return loading && isProcessing == false ? (
                    <CircularProgress color="inherit" size={24} />
                  ) : (
                    'Download file'
                  )
                }}
              </PDFDownloadLink>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default withStyles(styles)(PdfCourse)
